window.parseDate = function(date_string) {
  const date_data = date_string.match(/^(\d+)年(\d+)月(\d+).+/);
  return new Date(date_data[1], date_data[2]-1, date_data[3]);
}
